module.exports = __webpack_public_path__ + "img/Realistic-3D-Red-Roses-Tattoo-On-Girl-Half-Sleeve.jpg";